import { useNavigate } from "react-router-dom"
import { CellContext } from "@tanstack/react-table"
import styled from "styled-components"

import { UITypes } from "types"

const Container = styled.div<{ $isClickable: boolean }>`
  text-decoration: ${({ $isClickable }) => ($isClickable ? "underline" : "none")};
  color: ${({ $isClickable }) => ($isClickable ? "#2db2c8" : "#0f172a")};
  cursor: ${({ $isClickable }) => ($isClickable ? "pointer" : "default")};

  &:hover {
    opacity: ${({ $isClickable }) => ($isClickable ? "0.8" : "1")};
  }
`

interface CustomerEmailProps {
  cell: CellContext<UITypes.TableBodyRow, UITypes.TableBodyCell>
}

export const CustomerEmail = ({ cell }: CustomerEmailProps) => {
  const navigate = useNavigate()
  const customerEmail = cell.getValue().value as string
  const rowItem = cell.row.original.rowSettings.item
  const rowSettings = cell.row.original.rowSettings
  const customerId: number | null = rowItem.client_id || rowSettings.id || null
  const deviceSN: string | undefined = rowItem.sn
  const devicesCount: number | undefined = rowItem.devices_count
  const isInstalled = rowItem.phisical_status === "installed"

  const isClickable = !!(deviceSN || (devicesCount !== undefined && devicesCount > 0))

  const handleCustomerClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation()
    if (!customerId || !isClickable) return

    const baseUrl = `/customers/${customerId}/overview`
    const url = deviceSN ? `${baseUrl}?selectedDevice=${deviceSN}` : baseUrl
    navigate(url)
  }

  const getCustomerEmail = () => {
    if (devicesCount !== undefined) {
      return customerEmail || ""
    }

    if (!isInstalled) {
      return ""
    }

    return customerEmail || ""
  }

  return (
    <Container $isClickable={isClickable} onClickCapture={isClickable ? handleCustomerClick : undefined}>
      {getCustomerEmail()}
    </Container>
  )
}
